import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "container"]

  connect() {
    // Start hidden by default
    if (this.hasContainerTarget) {
      this.containerTarget.style.overflow = "hidden"
      this.containerTarget.style.transition = "max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-bottom 0.3s ease-in-out"

      // Hide on initial load
      this.containerTarget.style.maxHeight = "0"
      this.containerTarget.style.opacity = "0"
      this.containerTarget.style.marginBottom = "0"
    }
  }

  toggle(event) {
    event.preventDefault()

    if (!this.hasContainerTarget) return

    const container = this.containerTarget
    const isHidden = container.style.maxHeight === "0px" || container.style.maxHeight === ""

    if (isHidden) {
      if (this.hasTriggerTarget) this.triggerTarget.classList.add("!bg-gray-200")
      // Show notifications - slide down
      // First, measure the actual height
      container.style.display = "block"
      container.style.maxHeight = "none"
      const height = container.scrollHeight
      container.style.maxHeight = "0"

      // Force reflow
      container.offsetHeight

      // Animate to actual height
      requestAnimationFrame(() => {
        container.style.maxHeight = `${height}px`
        container.style.opacity = "1"
        container.style.marginBottom = "1rem" // Add spacing when visible
      })
    } else {
      if (this.hasTriggerTarget) this.triggerTarget.classList.remove("!bg-gray-200")
      // Hide notifications - slide up
      container.style.maxHeight = "0"
      container.style.opacity = "0"
      container.style.marginBottom = "0"

      // Restore display: none after animation completes to remove from flex flow
      setTimeout(() => {
        if (container.style.maxHeight === "0px" || container.style.maxHeight === "0") {
          container.style.display = "none"
        }
      }, 300) // Match transition duration
    }
  }
}
